<div *ngIf="field" [ngStyle]="{'display': userCanView || alwaysShowControl ? '': 'none', 'min-width': width}">
    <ng-container [ngSwitch]="field.ControlTypeID">
        <!-- Textbox -->
        <ng-container *ngSwitchCase="controlTypes.Textbox">
            <ng-container [ngSwitch]="field.DataTypeID">
                <!-- Integer -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Integer" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName' [name]='field.FieldName' type='number' [(ngModel)]='value' (ngModelChange)="valueChangeHandler()" 
                        [required]='field.IsRequired' [disabled]="field.ReadOnly"
                    />
                </tyl-form-field>
                <!-- Decimal -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Decimal" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName' [name]='field.FieldName' type='number' [(ngModel)]='value' (ngModelChange)="valueChangeHandler()" 
                    [required]='field.IsRequired' [disabled]="field.ReadOnly"
                />
                </tyl-form-field>
                <!-- Telephone -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Telephone" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName' [name]='field.FieldName' type='text' [(ngModel)]='telephoneDisplayValue' (ngModelChange)="telephoneValueChanged()" 
                    [required]='field.IsRequired' [disabled]="field.ReadOnly" [textMask]="{mask: phoneMask}"
                />
                </tyl-form-field>
                <!-- Email -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="dataTypes.Email"  class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName' [name]='field.FieldName' type='text' [(ngModel)]='value' (ngModelChange)="valueChangeHandler()" 
                    [required]='field.IsRequired' [disabled]="field.ReadOnly" minLength="{{field.StartRange ? field.StartRange : 0}}" 
                    maxLength="{{field.EndRange > 0 ? field.EndRange : 99999}}"
                />
                </tyl-form-field>
                <!-- Alphanumeric - Other -->
                <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchDefault  class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
                    <input #control matInput [id]='field.FieldName' [name]='field.FieldName' type='text' [(ngModel)]='value' (ngModelChange)="valueChangeHandler()" 
                    [required]='field.IsRequired' [disabled]="field.ReadOnly" minLength="{{field.StartRange ? field.StartRange : 0}}" 
                    maxLength="{{field.EndRange > 0 ? field.EndRange : 99999}}"
                />
                </tyl-form-field>
            </ng-container>
        </ng-container>
        <!-- Date -->
        <tyl-datepicker #control *ngSwitchCase="controlTypes.Date" [id]="field.FieldName" (valueChange)="dateValueChanged($event)" [customHint]="hintLabel" [ngStyle]="{'width': width}"
            [label]='hideLabel ? "" : field.DisplayName' [value]="value" [isRequired]="field.IsRequired" class="customDataField" [disabled]="field.ReadOnly" (dateInputChange)="timeControl = $event">
        </tyl-datepicker>
        <!-- Time -->
        <tyl-time-field #timeInput *ngSwitchCase="controlTypes.Time" class="customDataField" [label]='hideLabel ? "" : field.DisplayName' [id]='field.FieldName' [name]='field.FieldName'
        [required]='field.IsRequired' [disabled]="field.ReadOnly" [(timeValue)]="value" (timeValueChange)="valueChangeHandler()" (timeFieldChange)="timeControl = $event" [customHint]="hintLabel"></tyl-time-field>
        <!-- DateTime -->
        <ng-container *ngSwitchCase="controlTypes.DateTime">
            <tyl-datepicker #control [id]="field.FieldName" [label]='hideLabel ? "" : field.DisplayName' (valueChange)="dateValueChanged($event)" [ngStyle]="{'width': width}"
            [(value)]="value" [isRequired]="field.IsRequired" [disabled]="field.ReadOnly" class="customDataField"  [customHint]="hintLabel">
            </tyl-datepicker>
            <tyl-time-field #timeInput class="customDataField" [label]='hideLabel ? "" : field.DisplayName' [id]='field.FieldName' [name]='field.FieldName'
            [required]='field.IsRequired' [disabled]="field.ReadOnly" [timeValue]="localTimeValue" (timeValueChange)="timeValueChange($event)" (timeFieldChange)="timeControl = $event" [customHint]="hintLabel"></tyl-time-field>
        </ng-container>
        <!-- Checkbox -->
        <tyl-checkbox #control *ngSwitchCase="controlTypes.Checkbox" (change)="valueChangeHandler()"
            name="{{'cbName'+ '_' + field.FieldName + '_' + pageIndex}}" id="{{'cbID'+ '_' + field.FieldName + '_' + pageIndex}}" [(checked)]='value' [disabled]="field.ReadOnly">
            {{field.DisplayName}}
        </tyl-checkbox>
        <!-- Dropdown -->
        <tyl-form-field [label]='hideLabel ? "" : field.DisplayName' *ngSwitchCase="controlTypes.Dropdown" class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
            <mat-select #control id='{{"cst_" + field.FieldName}}' [(ngModel)]='value' name='{{"cst_" + field.FieldName}}' (selectionChange)="valueChangeHandler()" 
                [required]='field.IsRequired' [disabled]="field.ReadOnly">
                <mat-option *ngFor='let opt of field.Options' [value]='opt.Id'>{{opt.Description}}</mat-option>
            </mat-select>
        </tyl-form-field>
        <!-- Radio Buttons -->
        <tyl-radio-group #control
            *ngSwitchCase="controlTypes.RadioButtons"
            [label]='hideLabel ? "" : field.DisplayName'
            [(selected)]='value'
            [values]="values"
            [labels]="labels"
            [ids]="ids"
            arrange='vertical'
            [required]='field.IsRequired'
            [disabled]="field.ReadOnly">
        </tyl-radio-group>
        <!-- Buttons -->
        <div *ngSwitchCase="controlTypes.Buttons" style="flex-direction: column;">
            <label>{{hideLabel ? "" : field.DisplayName}} <span *ngIf="field.IsRequired" style="color:red;">*</span>
            </label>
            <mat-chip-list #control [id]="'chipList' + field.FieldName"  [disabled]="field.ReadOnly">
                <mat-chip [id]="'chip' + field.FieldName + '_' + chip.Code" *ngFor='let chip of field.Options'
                    [selected]='value == chip.Id' (click)="value = chip.Id" (selectionChange)="valueChangeHandler()">
                    {{chip.Description}}
                </mat-chip>
            </mat-chip-list>
        </div>
        <!-- Multi-line Checkbox -->
        <tyl-form-field *ngSwitchCase="controlTypes.MultiLineTextbox" [label]='hideLabel ? "" : field.DisplayName' class="customDataField" [hintLabel]="hintLabel" [ngStyle]="{'width': width}">
            <textarea #control matInput [id]="'txt' + field.FieldName" [required]="field.IsRequired"  [disabled]="field.ReadOnly" [rows]="noteRows"
                [(ngModel)]='value' [name]="'ta' + field.FieldName" (change)="valueChangeHandler()" [minLength]="field.StartRange" [maxLength]="field.EndRange">
            </textarea>
        </tyl-form-field>
        <!-- Text -->
        <quill-editor #control *ngSwitchCase="controlTypes.Text" [ngModel]="value" [readOnly]="true" placeholder="" class="ql-textOnly" 
            [name]="'quill' + field.FieldName" class="customDataField">
        </quill-editor>
    </ng-container>
</div>